import React from "react";
import AntTabs from "./antDesignSign/AntTabs";
import { useFormik } from "formik";
import * as Yup from "yup";
import './login.css'

export default function ResetPassword() {
  const loginSchema = Yup.object().shape({
    // searchType: Yup.string().required("Login Type is required"),
    // user: Yup.string()
    //   .min(0)
    //   .required("Email is Required")
    //   .matches(
    //     /^\w+([\.-]?\w+)@\w+([\.-]?\w+)(\.\w{2,3})+$/,
    //     "Please! Enter a valid email address"
    //   ),
    email: Yup.string()
      .min(0)
      .required("Email is required").email('Please! Enter a valid email address'),
    password: Yup.string()
      .min(8)
      .required("Password is Required")
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/,
        "Minimum eight characters, at least one uppercase letter, one lowercase letter and one number"
      ),
      confirmPassword: Yup.string()
      .oneOf([Yup.ref('password'),], 'Passwords must match')
      .required('Required'),    
    registerType: Yup.string(),
    refId: Yup.string().min(0),
    pin:Yup.number().required('Pin Required')
  });
  const formik = useFormik({
    initialValues: {
      registerType: "email",
      email: "",
      password: "",
      refId: "",
      user_id: "",
      pin:null,
      confirmPassword:""
    },
    validationSchema: loginSchema,

    onSubmit: async (values, action) => {


      let newValues = values;
      // setLoading(true);
      // if (values.registerType == "email") {
      //   let checkuser = await AXIOS.post('/checkUser', {
      //     api_key: api_key,
      //     registerType: values.registerType,
      //     data: values.email,
      //     password: values.password
      //   })
        
      //   if (checkuser.data.status == 'fail') {
      //     if (checkuser.data.showableMessage == 'Email not registered') {
      //       formik.setErrors({
      //         ...formik.errors,
      //         email: 'invalid emial'
      //       })
      //     }
      //     else{
      //       formik.setErrors({
      //         ...formik.errors,
      //         password: 'invalid password'
      //       })
      //     }
      //     toast.error(checkuser.data.showableMessage, { icon: <MdEmail /> });
      //     setLoading(false);



      //   }

      //   else {
      //     let id = await AXIOS.post(`/getUserId`, {
      //       api_key: api_key,
      //       email: values.email,
      //     });
      //     newValues = { ...values, user_id: id.data.data[0].user_id };
      //     await AXIOS.post(`/sendMail`, {
      //       api_key: api_key,
      //       user_id: id.data.data[0].user_id,
      //       reason: "login_verification",
      //     })
      //       .then((response) => {
      //         toast.success("Pin code sent to Email", { icon: <MdEmail /> });

      //         setData(newValues);
      //         setLoading(false);
      //         handleShow();
      //       })
      //       .catch((error) => {
      //         toast.error("Email not sent", { icon: <MdEmail /> });
      //       });
      //   }

      // } else {

      //   return 0
      //   await AXIOS.post(`/sendSMSPin`, {
      //     api_key: api_key,
      //     email: values.email,
      //   })
      //     .then((response) => {
      //       toast.success("Pin code sent to Phone Number", { icon: <MdSms /> });
      //       setData(newValues);
      //       setLoading(false);
      //       handleShow();
      //     })
      //     .catch((error) => {
      //       toast.error("Sms not sent", { icon: <MdSms /> });
      //     });
      // }
    },
  });
  return (
    <div className="container mt-5 mb-5 reset_pass d-flex justify-content-center">
      <div className="row reset_pass_row">
        <div className="col">
        
          <div className="tabs">
            <AntTabs formik={formik}/>
          </div>
         
        </div>
      </div>
    </div>
  );
}
